import { render, staticRenderFns } from "./Mixingplant.vue?vue&type=template&id=6a23bcfa"
import script from "./Mixingplant.vue?vue&type=script&lang=js"
export * from "./Mixingplant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports